var map = {
	"./de.json": [
		369,
		369
	],
	"./en.json": [
		389,
		389
	],
	"./es.json": [
		8302,
		302
	],
	"./fr.json": [
		5222,
		222
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 5079;
module.exports = webpackAsyncContext;